/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../../styledElement-Dm1irIE2.js";
import { t } from "../../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../../decorate-DHgd5sZx.js";
import { FormElement as r } from "../../formElement.js";
import "../../form-elements/select.js";
import "../../form-elements/text-input.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
//#region src/elements/employee-questionnaire/shared/health-insurance-section.ts
var u = [
	{
		label: "Gesetzlich",
		value: "statutory"
	},
	{
		label: "Privat",
		value: "private"
	},
	{
		label: "Im Ausland versichert",
		value: "abroad"
	},
	{
		label: "Sonstiges",
		value: "other"
	}
], d = class extends e(r(i)) {
	constructor(...e) {
		super(...e), this.data = {}, this._ensuranceType = "", this._otherEnsuranceType = "", this._lastEnsurance = "", this._ensurerName = "";
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._ensuranceType = this.data.ensuranceType ?? "", this._otherEnsuranceType = this.data.otherEnsuranceType ?? "", this._lastEnsurance = this.data.lastEnsurance ?? "", this._ensurerName = this.data.ensurerName ?? "");
	}
	_handleSectionChange() {
		this._ensuranceType !== "other" && (this._otherEnsuranceType = ""), this._ensuranceType !== "private" && (this._lastEnsurance = ""), this.dispatchEvent(new CustomEvent("change", {
			detail: {
				ensuranceType: this._ensuranceType || void 0,
				otherEnsuranceType: this._otherEnsuranceType || void 0,
				lastEnsurance: this._lastEnsurance || void 0,
				ensurerName: this._ensurerName || void 0
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-4 px-2 text-xl font-semibold">Krankenversicherung</h2>

                <div class="flex flex-col gap-4">
                    <div class="flex gap-4">
                        <div class="flex-1">
                            <ptc-ui-select
                                .options=${u}
                                name="ensuranceType"
                                label="Art der Versicherung"
                                .value=${this._ensuranceType}
                                @change=${(e) => {
			e.stopPropagation(), this._ensuranceType = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-select>
                        </div>

                        ${this._ensuranceType === "other" ? a`
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="otherEnsuranceType"
                                          label="Sonstige Versicherung"
                                          placeholder="Versicherung eingeben"
                                          .value=${this._otherEnsuranceType}
                                          maxlength="200"
                                          required
                                          @change=${(e) => {
			e.stopPropagation(), this._otherEnsuranceType = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>
                              ` : o}
                        ${this._ensuranceType === "private" ? a`
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          name="lastEnsurance"
                                          label="Letzte gesetzliche Versicherung"
                                          placeholder="Versicherung eingeben"
                                          .value=${this._lastEnsurance}
                                          maxlength="200"
                                          required
                                          @change=${(e) => {
			e.stopPropagation(), this._lastEnsurance = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>
                              ` : o}
                        ${this._ensuranceType !== "other" && this._ensuranceType !== "private" ? a`<div class="flex-1"></div>` : o}
                    </div>

                    <div class="flex gap-4">
                        <div class="flex-1">
                            <ptc-ui-text-input
                                name="ensurerName"
                                label="Name der Krankenkasse"
                                placeholder="Krankenkasse eingeben"
                                .value=${this._ensurerName}
                                maxlength="200"
                                @change=${(e) => {
			e.stopPropagation(), this._ensurerName = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-text-input>
                        </div>
                        <div class="flex-1"></div>
                    </div>
                </div>
            </section>
        `;
	}
};
n([c({ type: Object }), t("design:type", Object)], d.prototype, "data", void 0), n([l(), t("design:type", Object)], d.prototype, "_ensuranceType", void 0), n([l(), t("design:type", Object)], d.prototype, "_otherEnsuranceType", void 0), n([l(), t("design:type", Object)], d.prototype, "_lastEnsurance", void 0), n([l(), t("design:type", Object)], d.prototype, "_ensurerName", void 0), d = n([s("ptc-ui-employee-questionnaire-health-insurance-section")], d);
//#endregion
export { d as EmployeeQuestionnaireHealthInsuranceSection };

//# sourceMappingURL=health-insurance-section.js.map